// src/pages/Error404.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/components/Error404.css";

import dnaArt from "../img/hero/dna-art.webp";
import arrowCircle from "../img/hero/arrow-circle-2.png"; // ✅ та сама стрілка, що й у Services

export default function Error404() {
  const navigate = useNavigate();

  return (
    <section className="error404" aria-labelledby="err-title">
      {/* Великі “4” по краях */}
      <span className="error404__digit error404__digit--left" aria-hidden>
        4
      </span>
      <span className="error404__digit error404__digit--right" aria-hidden>
        4
      </span>

      {/* Центральне зображення */}
      <img className="error404__art" src={dnaArt} alt="" aria-hidden="true" />

      {/* Скляна плашка */}
      <div className="error404__glass">
        <h1 id="err-title" className="error404__title">
          Oops! This page doesn’t exist.
        </h1>
        <p className="error404__subtitle">
          The link may be broken or the page might have been removed.
          <br />
          Let’s get you back on track.
        </p>

        {/* 🔵 Кнопка як у Services */}
        <button
          className="Primary error404__cta"
          type="button"
          onClick={() => navigate("/")}
        >
          <span>Go to Homepage</span>
          <img src={arrowCircle} alt="" aria-hidden="true" />
        </button>
      </div>
    </section>
  );
}
